module.exports = __webpack_public_path__ + "img/Assurex_logo.fa36ae77.png";